import React from "react";
import StickyHeader from "../../../components/Layout/StickyHeader";
import { useNavigate } from "react-router-dom";
import HorizontalRule from "../../../components/Rule/Horizontal";
import CommonButton from "../../../components/Button";

type Props = {};

export default function ConfigSimpleLogin(props: Props) {
  const navigate = useNavigate();

  return (
    <div>
      <div className="px-5">
        <StickyHeader
          title="간편 로그인 설정하기"
          onBackClick={() => navigate("/myinfo")}
        />

        <div className="flex flex-col gap-2.5">
          <div className=" text-3xl whitespace-pre-line font-normal pt-5">
            <strong>간편 로그인</strong>
            {"으로\n편리하게 이용해보세요"}
          </div>
          <div className=" text-brand-neutral-50 text-base">
            간편 로그인 연결을 바꿀 수 있습니다
          </div>
        </div>

        <HorizontalRule className="bg-black !mt-[33px]" />
        <div className="flex justify-between px-2.5">
          <div className="flex items-center gap-2.5 text-lg font-medium">
            <LgIdIcon />
            MY LG ID
          </div>
          <CommonButton variant="info" className="text-xs !p-2.5">
            연결하기
          </CommonButton>
        </div>
        <HorizontalRule />
      </div>
    </div>
  );
}

export const LgIdIcon = () => (
  <svg
    width="40"
    height="41"
    viewBox="0 0 40 41"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="20" cy="20.9951" r="20" fill="#A61B39" />
    <path
      d="M29.2838 16.5947H26.3683C26.2893 16.5947 26.2247 16.6594 26.2247 16.7383V21.8124C26.2247 22.3021 26.6211 22.6985 27.1108 22.6985C27.6006 22.6985 27.9969 22.3021 27.9969 21.8138V17.9907H29.2464C30.9584 17.9907 32.001 18.8883 32.001 20.8789C32.001 23.2945 30.8119 24.0227 28.8701 24.0227H24.563V16.7383C24.563 16.6594 24.4984 16.5947 24.4194 16.5947H22.9344C22.8554 16.5947 22.7908 16.6594 22.7908 16.7383V25.2506C22.7908 25.3296 22.8554 25.3942 22.9344 25.3942H28.9434C31.7353 25.3942 33.8594 24.3142 33.8594 21.0254C33.8594 17.7365 32.1963 16.5947 29.2838 16.5947Z"
      fill="white"
    />
    <path
      d="M8.12035 16.7216H6.14062V25.2679H12.2206V23.6046H8.12035V16.7216ZM16.5746 22.0111H18.1876V23.5056C17.7262 23.6562 17.2438 23.7315 16.76 23.7301C14.9783 23.7301 14.3844 22.8281 14.3844 20.9947C14.3844 19.1614 14.949 18.2161 16.7307 18.2161C17.7206 18.2161 18.2866 18.527 18.7523 19.1182L19.9833 17.9889C19.2333 16.9196 17.9186 16.5947 16.6889 16.5947C13.9173 16.5947 12.4618 18.1032 12.4618 20.9808C12.4618 23.8584 13.7765 25.3947 16.675 25.3947C18.0036 25.3947 19.3044 25.0559 20.0112 24.5624V20.4175H16.576V22.0111H16.5746Z"
      fill="white"
    />
  </svg>
);
